import { render, staticRenderFns } from "./AddCourseResource.vue?vue&type=template&id=2eb94303&scoped=true"
import script from "./AddCourseResource.vue?vue&type=script&lang=js"
export * from "./AddCourseResource.vue?vue&type=script&lang=js"
import style0 from "./AddCourseResource.vue?vue&type=style&index=0&id=2eb94303&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb94303",
  null
  
)

export default component.exports